module.exports = __webpack_public_path__ + "static/media/lease2_img5.50639976.jpg";